/*
  Returns the URL unchanged if it is an absolute URL
  Else, appends with REACT_APP_MAIN_STORE_API_HOST.
*/
const URLSanitizer = {
    makeAbsolute: (url) => {
        if (url.indexOf('http') !== -1) {
            return url;
        }

        return `${process.env.REACT_APP_MAIN_STORE_API_HOST}${url}`;
    },
};

export default URLSanitizer;



/** WEBPACK FOOTER **
 ** ./src/services/url-sanitizer.js
 **/